var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204c9e",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#db362f",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#db362f",
    d: "M14.65 6.23s.18 1.79.18 5.36c-.03 3.64-2.75 5.49-4.75 6.46-2-.98-4.73-2.82-4.76-6.46 0-3.57.18-5.36.18-5.36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#204c9e",
    d: "M10.08 18.04a9 9 0 0 0 3.74-3.03l-.02-.05c-.56-1.18-1.58-1.37-2.27-.4a3 3 0 0 0-.3-.57c-.8-1.18-1.97-.93-2.61.56q-.44-.6-1.01-.61c-.52 0-.98.42-1.27 1.07a9 9 0 0 0 3.74 3.03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.67 15.95v-4.47c-1.5 0-1.94.14-2.39.27a8 8 0 0 0 0-1.37c.45.14.88.27 2.4.27V9.41c-.48 0-1.14.02-1.9.28a7 7 0 0 0 0-1.37c.76.25 1.42.27 1.9.27 0-.36-.12-1.13-.26-1.77q.66.06 1.31 0c-.14.64-.25 1.4-.25 1.77a6 6 0 0 0 1.9-.27 7 7 0 0 0 0 1.37 6 6 0 0 0-1.9-.28v1.24c1.51 0 1.94-.13 2.4-.27a8 8 0 0 0 0 1.37c-.46-.13-.89-.27-2.4-.27v4.47z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.08 18.24 10 18.2a10 10 0 0 1-3.17-2.27 6.4 6.4 0 0 1-1.68-4.34c0-3.54.18-5.36.18-5.37l.02-.16h9.46l.01.16c0 .01.18 1.83.18 5.37a6.4 6.4 0 0 1-1.68 4.34q-1.16 1.3-3.17 2.27zM5.66 6.4c-.04.5-.16 2.25-.16 5.19a6 6 0 0 0 1.59 4.11 10 10 0 0 0 2.99 2.15 10 10 0 0 0 2.99-2.15 6 6 0 0 0 1.59-4.12c0-2.93-.13-4.67-.17-5.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/slovakia.8972417a4997a1879b1f5540d3c8b283.svg";
export { ForwardRef as ReactComponent };